"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Como funciona o período de 30 dias grátis?",
    answer: "Configuramos sua conta assim que você entrar em contato. Zero taxas iniciais, zero cartão de crédito. Você testa tudo na prática e só paga se o Agendei fizer sentido para o seu negócio.",
  },
  {
    question: "Preciso baixar algum aplicativo?",
    answer: "Não. Somos uma plataforma web progressiva (PWA). Seus clientes podem agendar direto do navegador ou instalar o site na tela inicial do celular em 1 clique, sem ocupar a memória do aparelho.",
  },
  {
    question: "Posso usar meu próprio domínio (.com.br)?",
    answer: "Sim! Se você já tem um domínio, nós conectamos para você. Caso contrário, você ganha um subdomínio profissional gratuito.",
  },
  {
    question: "E se eu precisar de ajuda para configurar?",
    answer: "Nós fazemos isso por você. Nossa equipe te ajuda a cadastrar seus serviços, horários e profissionais via WhatsApp para você não perder tempo.",
  },
];

export function FAQ() {
  return (
    <section className="py-12 md:py-20 relative z-10">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Dúvidas frequentes
          </h2>
        </div>
        
        <div className="bg-[#0a0a0a]/80 backdrop-blur-md border border-white/10 rounded-3xl p-6 md:p-10">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-white/10 last:border-0 py-2">
                <AccordionTrigger className="text-left text-lg font-bold text-white hover:text-primary transition-colors hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 text-base leading-relaxed pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
